"use client";

import { useContext } from "react";
import TokenContext from "@/context/TokenProvider";
import CssBaseline from "@mui/material/CssBaseline";
import { UserNavbarTop } from "@/layout/Navbar/Top";
import UserNavbarSide from "@/layout/Navbar/Side/UserNavbarSide";
import QrCodeScanButton from "@/components/dialog/QrCodeScanButton";
import UserFooter from "@/layout/Footer/UserFooter";
import { useProfile } from "@/utils/Hooks";

export const UserLayoutClient = (props) => {
  const { accessToken, authenticatedFetcher } = useContext(TokenContext)!;
  const { data, mutate } = useProfile(authenticatedFetcher);

  return <>
    <CssBaseline/>
    <UserNavbarTop/>
    <UserNavbarSide/>

    <main>
      {props.children}
    </main>

    <UserFooter/>

    {accessToken && <QrCodeScanButton accessToken={accessToken} profile={{ data, mutate }}/>}
  </>;
};